/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import { FiraSansBold } from 'components/Text';
import Colors from 'constants/Colors';
import PropTypes from 'prop-types';
import { FontWeight } from 'components/Text';
import {Breakpoints} from "../../constants/Breakpoints";
import { mediaHelperMaxWidth } from "../../utils/src";

const propTypes = {
    canShow: PropTypes.bool,
    pink:PropTypes.string
  };

const Dialog = styled.div`
position: fixed; 
z-index: 5; 
padding-top: 5vh;
left: 0;
top: 0;
width: 100%; 
height: 100%; 
overflow: hidden; 
background-color: rgba(255,255,255,0.4);
backdrop-filter: blur(1px);

${({ canShow }) =>
canShow
  ? css`
      display: block;
      `
  : `display: none;`
}

@media screen and (min-width: ${Breakpoints.sm}) {
    padding-top: 5vh;
}

  @media screen and (min-width: ${Breakpoints.xl}) {
    padding-top: 15vh;
  }


  ${mediaHelperMaxWidth.md`
    padding-top: 2vh;
  `}
`;

const DialogBody = styled.div` 
    background-color: #fefefe;
    margin: auto auto 150px;
    padding: 25px;
    box-shadow: rgb(192 192 192) 0px 1px 5px 2px;
    width: 500px;
    max-height: 540px;
    min-height: 100px;
    border-radius: 4px;
    overflow-y: auto;
    position: absolute;
    left: calc(40% + 175px);
    transform: translate(-50%, 0);
    overscroll-behavior: none;
  
    @media screen and (min-width: ${Breakpoints.sm}) {
      left: 50%;
    }

    ${mediaHelperMaxWidth.md`
      width: 90%;
      left: 50%;
      max-height: calc(100% - 65px)
    `}
`;

const DialogIcon = styled.div`
    height: 30px;
    display: block;
    width: 100%;
    ${({ pink }) =>
    pink == "exclamation"
      ? css`
          color: ${Colors.PINK};
          `
      : `display: ${Colors.BLACK};`
    }
    
    font-size: 22px;
    svg{
      float: left;
    }
`;

const DialogText = styled.p`
    display: block;
    color: ${Colors.GRAY[6]};
    font-weight: ${FiraSansBold};
    font-family: 'Fira Sans', sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    float: left;
    margin: 0px;
    margin-left: 8px;
    margin-top: 1px;
`;

export {Dialog, DialogBody, DialogIcon, DialogText};



